import { isResourceResponseDTO, ResourceResponseApi } from "../Resource/Resource";

export type ResourceWithContentResponseApi = ResourceResponseApi & {
  resourceFormat: string;
  resourceIsDownloadable: boolean;
} & ({ resourceBufferString: string } | { resourceLink: string });

export let isResourceWithFileResponseDTO = (
  variable: ResourceResponseApi
): variable is ResourceResponseApi & { resourceBufferString: string } => {
  return (
    "resourceBufferString" in variable &&
    typeof variable.resourceBufferString === "string"
  );
};

export let isResourceWithLinkResponseDTO = (
  variable: ResourceResponseApi
): variable is ResourceResponseApi & { resourceLink: string } => {
  return (
    "resourceLink" in variable && typeof variable.resourceLink === "string"
  );
};

export let isResourceWithContentResponseDTO = (
  variable: unknown
): variable is ResourceWithContentResponseApi => {
  return (
    isResourceResponseDTO(variable) &&
    "resourceFormat" in variable &&
    typeof variable.resourceFormat === "string" &&
    "resourceIsDownloadable" in variable &&
    typeof variable.resourceIsDownloadable === "boolean" &&
    (isResourceWithFileResponseDTO(variable) ||
      isResourceWithLinkResponseDTO(variable))
  );
};
